export default "__VITE_ASSET__BdodIM0D__"